import script from "./UserAssessmentScores.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAssessmentScores.vue?vue&type=script&setup=true&lang=js"

import "./UserAssessmentScores.vue?vue&type=style&index=0&id=3957a5e2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3957a5e2"]])

export default __exports__